import { observer } from 'mobx-react';
import { BasicInfo } from './basic-info/basic-info';
import styles from './bidder-advertiser-form.module.scss';

type Props = {
	isEdit?: boolean;
};

export const BidderAdvertiserForm = observer(({ isEdit }: Props) => {
	return (
		<div className={styles.wrapper}>
			<BasicInfo isEditPage={isEdit ?? false} />
		</div>
	);
});
